import { css, styled } from 'styled-components';
import { BREAKPOINTS } from '../../../constants/layout.mjs';
import { theme } from '../../../constants/theme.mjs';
import '../../Button/index.mjs';
import { Button as Button$1 } from '../../Button/Button.mjs';
"use strict";
const visbility = css`
  ${({
  $hideOnMobile
}) => $hideOnMobile && css`
      @media ${BREAKPOINTS.TOP_NAV_MOBILE_AND_DOWN} {
        display: none;
      }
    `}

  ${({
  $hideOnDesktop
}) => $hideOnDesktop && css`
      @media ${BREAKPOINTS.TOP_NAV_MOBILE_UP} {
        display: none;
      }
    `}
`;
const MenuButtonWrap = styled.div`
  display: flex;
  align-items: center;
  outline: none;

  ${visbility}
`;
const MenuButtonLink = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1;
  letter-spacing: -0.02em;

  transition: background-color 0.3s ease 0s;

  ${({
  $motif
}) => {
  switch ($motif) {
    case "dark":
      return css`
          color: ${theme.colors.white};
          background-color: #005ed9;

          &:focus,
          &:hover {
            color: ${theme.colors.white};
            background-color: #004cad;
          }
        `;
    case "light":
    default:
      return css`
          color: ${theme.colors.white};
          background-color: ${theme.colors.primaryBlue};

          &:focus,
          &:hover {
            color: ${theme.colors.white};
            background-color: ${theme.colors.dodgerblue};
          }
        `;
  }
}}

  ${({
  $secondary,
  $motif
}) => $secondary && css`
      border: 1px solid #595959;
      background-color: transparent;

      ${$motif === "light" && css`
        color: ${theme.colors.menu.text.light};

        &:focus,
        &:hover {
          color: ${theme.colors.primaryBlue};
        }
      `}

      &:focus,
      &:hover {
        background-color: transparent;
        border-color: ${theme.colors.primaryBlue};
      }
    `}
`;
const TextWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100%;
`;
const Text = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  transition: color 0.2s linear;
  font-size: 14px;
  line-height: ${20 / 14};
`;
const Arrow = styled.div`
  border: 3px solid transparent;
  border-bottom: none;
  border-top: 5px solid currentcolor;
  transition: color 0.2s linear;
`;
const ArrowIconWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  display: flex;
  margin: 1px 0 0 4px;

  ${({
  $flip
}) => $flip && css`
      margin-top: 0;

      ${Arrow} {
        transform: rotate(180deg);
      }
    `}
`;
const Button = styled(Button$1)`
  display: flex;
  border: none;
  background: none;
  align-items: center;
  justify-content: center;
  outline: none;
  white-space: nowrap;
  height: 100%;
  cursor: pointer;
  padding: 0;
  color: ${({
  $motif
}) => theme.colors.menu.text[$motif]};
  position: relative;

  &:hover,
  &:focus {
    ${Text},
    ${ArrowIconWrap} {
      color: ${({
  $motif
}) => theme.colors.menu.active[$motif]};
    }
  }

  ${({
  $showArrow
}) => $showArrow && css`
      margin-right: 5px;
    `}

  ${({
  $minWidth
}) => $minWidth != null && css`
      min-width: ${$minWidth}px;
    `};

  ${({
  $active,
  $motif
}) => $active && css`
      ${Text} {
        color: ${theme.colors.menu.active[$motif]};
      }

      ${ArrowIconWrap} {
        color: ${theme.colors.menu.active[$motif]};
      }
    `}

  ${visbility}
`;
export { Arrow, ArrowIconWrap, Button, MenuButtonLink, MenuButtonWrap, Text, TextWrap };
//# sourceMappingURL=MenuItem.styles.mjs.map
